import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'

const _79013404 = () => interopDefault(import('../src/pages/companies/index.vue' /* webpackChunkName: "pages/companies/index" */))
const _50197294 = () => interopDefault(import('../src/pages/logout.vue' /* webpackChunkName: "pages/logout" */))
const _0892b4cd = () => interopDefault(import('../src/pages/sign_in.vue' /* webpackChunkName: "pages/sign_in" */))
const _1765b428 = () => interopDefault(import('../src/pages/google-calendar/callback.vue' /* webpackChunkName: "pages/google-calendar/callback" */))
const _3bdc6160 = () => interopDefault(import('../src/pages/initial-settings/company-profile.vue' /* webpackChunkName: "pages/initial-settings/company-profile" */))
const _25e5819e = () => interopDefault(import('../src/pages/initial-settings/invite-members.vue' /* webpackChunkName: "pages/initial-settings/invite-members" */))
const _03403c30 = () => interopDefault(import('../src/pages/initial-settings/user-profile.vue' /* webpackChunkName: "pages/initial-settings/user-profile" */))
const _059f71f7 = () => interopDefault(import('../src/pages/sessions/branu-logout.vue' /* webpackChunkName: "pages/sessions/branu-logout" */))
const _45d5f5dd = () => interopDefault(import('../src/pages/sessions/callback.vue' /* webpackChunkName: "pages/sessions/callback" */))
const _3f63e357 = () => interopDefault(import('../src/pages/sessions/callback-with-branu-user.vue' /* webpackChunkName: "pages/sessions/callback-with-branu-user" */))
const _35f82331 = () => interopDefault(import('../src/pages/sessions/invitation.vue' /* webpackChunkName: "pages/sessions/invitation" */))
const _58984e32 = () => interopDefault(import('../src/pages/contents/_uuid/index.vue' /* webpackChunkName: "pages/contents/_uuid/index" */))
const _079197b3 = () => interopDefault(import('../src/pages/companies/_company_id/attendance-summary.vue' /* webpackChunkName: "pages/companies/_company_id/attendance-summary" */))
const _56b2a5d4 = () => interopDefault(import('../src/pages/companies/_company_id/construction-kinds.vue' /* webpackChunkName: "pages/companies/_company_id/construction-kinds" */))
const _74f9be65 = () => interopDefault(import('../src/pages/companies/_company_id/construction-kinds/new.vue' /* webpackChunkName: "pages/companies/_company_id/construction-kinds/new" */))
const _cbfc7a18 = () => interopDefault(import('../src/pages/companies/_company_id/customers.vue' /* webpackChunkName: "pages/companies/_company_id/customers" */))
const _13354b85 = () => interopDefault(import('../src/pages/companies/_company_id/customers/new.vue' /* webpackChunkName: "pages/companies/_company_id/customers/new" */))
const _325a49e2 = () => interopDefault(import('../src/pages/companies/_company_id/customers/_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/customers/_id/index" */))
const _7b60152a = () => interopDefault(import('../src/pages/companies/_company_id/customers/_id/edit.vue' /* webpackChunkName: "pages/companies/_company_id/customers/_id/edit" */))
const _4e35cfc0 = () => interopDefault(import('../src/pages/companies/_company_id/expiration.vue' /* webpackChunkName: "pages/companies/_company_id/expiration" */))
const _64040378 = () => interopDefault(import('../src/pages/companies/_company_id/members.vue' /* webpackChunkName: "pages/companies/_company_id/members" */))
const _1b10fc08 = () => interopDefault(import('../src/pages/companies/_company_id/profile.vue' /* webpackChunkName: "pages/companies/_company_id/profile" */))
const _39c7caab = () => interopDefault(import('../src/pages/companies/_company_id/projects.vue' /* webpackChunkName: "pages/companies/_company_id/projects" */))
const _c6433624 = () => interopDefault(import('../src/pages/companies/_company_id/projects/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/index" */))
const _5315445c = () => interopDefault(import('../src/pages/companies/_company_id/projects/calendar.vue' /* webpackChunkName: "pages/companies/_company_id/projects/calendar" */))
const _6936ae84 = () => interopDefault(import('../src/pages/companies/_company_id/projects/gantt-chart/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/gantt-chart/index" */))
const _669ac088 = () => interopDefault(import('../src/pages/companies/_company_id/projects/new.vue' /* webpackChunkName: "pages/companies/_company_id/projects/new" */))
const _106ede44 = () => interopDefault(import('../src/pages/companies/_company_id/projects/resource-allocation/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/resource-allocation/index" */))
const _241aabf7 = () => interopDefault(import('../src/pages/companies/_company_id/projects/resource-allocation/devices-allocation/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/resource-allocation/devices-allocation/index" */))
const _6abe0a7c = () => interopDefault(import('../src/pages/companies/_company_id/projects/resource-allocation/member-allocation/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/resource-allocation/member-allocation/index" */))
const _8e066a54 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id" */))
const _02ff58d9 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/index" */))
const _5c0bb8f5 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/index" */))
const _62a5b7c4 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/index" */))
const _516375c8 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/card/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/card/index" */))
const _15825c4c = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/detail.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/detail" */))
const _ed59b816 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/ledger/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/ledger/index" */))
const _39da10ba = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/member.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/member" */))
const _027fad89 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/reports/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/reports/index" */))
const _27c8ff63 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/index" */))
const _2fc83709 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/summary.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/summary" */))
const _37182dfa = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/user-list.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/user-list" */))
const _c940e826 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/user-records.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/user-records" */))
const _d9a1e61e = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/utils.ts' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/utils" */))
const _3330d040 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/utils/user-list.ts' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/utils/user-list" */))
const _6cbcb012 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/new.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/new" */))
const _16cea108 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/posts/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/posts/index" */))
const _0446bf93 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/reports/select-daily-reports.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/reports/select-daily-reports" */))
const _76b02f7a = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/fullscreen.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/fullscreen" */))
const _091e15ce = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/preview.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/preview" */))
const _b355387e = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/print/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/print/index" */))
const _589b2e27 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/view/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/view/index" */))
const _72fec994 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/view/fullscreen.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/view/fullscreen" */))
const _18bb62a8 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/_board_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/_board_id/index" */))
const _5bbcdbba = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/files/_file_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/files/_file_id/index" */))
const _1fb5cba4 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/_board_id/edit.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/_board_id/edit" */))
const _62c6d290 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/_board_id/files/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/_board_id/files/index" */))
const _49437e6e = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/files/_file_id/edit.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/files/_file_id/edit" */))
const _71efd7d9 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/files/_file_id/preview.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/files/_file_id/preview" */))
const _4938477a = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/reports/_report_id/form.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/reports/_report_id/form" */))
const _e9a8d3ce = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/reports/_report_id/preview.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/reports/_report_id/preview" */))
const _289f8121 = () => interopDefault(import('../src/pages/companies/_company_id/reports/index.vue' /* webpackChunkName: "pages/companies/_company_id/reports/index" */))
const _0930d52f = () => interopDefault(import('../src/pages/companies/_company_id/setting.vue' /* webpackChunkName: "pages/companies/_company_id/setting" */))
const _7aa76f1f = () => interopDefault(import('../src/pages/companies/_company_id/sharing-contents/index.vue' /* webpackChunkName: "pages/companies/_company_id/sharing-contents/index" */))
const _52178d70 = () => interopDefault(import('../src/pages/companies/_company_id/skills-register/index.vue' /* webpackChunkName: "pages/companies/_company_id/skills-register/index" */))
const _685d94e5 = () => interopDefault(import('../src/pages/companies/_company_id/unavailability.vue' /* webpackChunkName: "pages/companies/_company_id/unavailability" */))
const _2ac7bcd8 = () => interopDefault(import('../src/pages/companies/_company_id/user-profile.vue' /* webpackChunkName: "pages/companies/_company_id/user-profile" */))
const _0aac2ea7 = () => interopDefault(import('../src/pages/companies/_company_id/skills-register/analytics/index.vue' /* webpackChunkName: "pages/companies/_company_id/skills-register/analytics/index" */))
const _315c2004 = () => interopDefault(import('../src/pages/companies/_company_id/files/_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/files/_id/index" */))
const _53a1238c = () => interopDefault(import('../src/pages/companies/_company_id/reports/_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/reports/_id/index" */))
const _74fdcb14 = () => interopDefault(import('../src/pages/companies/_company_id/skills-register/_member_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/skills-register/_member_id/index" */))
const _f8cc1a70 = () => interopDefault(import('../src/pages/companies/_company_id/files/_id/edit.vue' /* webpackChunkName: "pages/companies/_company_id/files/_id/edit" */))
const _26831d0c = () => interopDefault(import('../src/pages/companies/_company_id/files/_id/preview.vue' /* webpackChunkName: "pages/companies/_company_id/files/_id/preview" */))
const _8f986ede = () => interopDefault(import('../src/pages/companies/_company_id/reports/_id/ai_pdf.vue' /* webpackChunkName: "pages/companies/_company_id/reports/_id/ai_pdf" */))
const _3a625e40 = () => interopDefault(import('../src/pages/companies/_company_id/reports/_id/edit.vue' /* webpackChunkName: "pages/companies/_company_id/reports/_id/edit" */))
const _9a4f07a8 = () => interopDefault(import('../src/pages/companies/_company_id/reports/_id/pdf.vue' /* webpackChunkName: "pages/companies/_company_id/reports/_id/pdf" */))
const _b7d80ad4 = () => interopDefault(import('../src/pages/companies/_company_id/project/_id/schedule/pdf.vue' /* webpackChunkName: "pages/companies/_company_id/project/_id/schedule/pdf" */))
const _7881ecb8 = () => interopDefault(import('../src/pages/index.vue' /* webpackChunkName: "pages/index" */))

Vue.use(Router)

if (process.client) {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual'

    // reset scrollRestoration to auto when leaving page, allowing page reload
    // and back-navigation from other pages to use the browser to restore the
    // scrolling position.
    window.addEventListener('beforeunload', () => {
      window.history.scrollRestoration = 'auto'
    })

    // Setting scrollRestoration to manual again when returning to this page.
    window.addEventListener('load', () => {
      window.history.scrollRestoration = 'manual'
    })
  }
}
const scrollBehavior = function (to, from, savedPosition) {
  // if the returned position is falsy or an empty object,
  // will retain current scroll position.
  let position = false

  // if no children detected and scrollToTop is not explicitly disabled
  if (
    to.matched.length < 2 &&
    to.matched.every(r => r.components.default.options.scrollToTop !== false)
  ) {
    // scroll to the top of the page
    position = { x: 0, y: 0 }
  } else if (to.matched.some(r => r.components.default.options.scrollToTop)) {
    // if one of the children has scrollToTop option set to true
    position = { x: 0, y: 0 }
  }

  // savedPosition is only available for popstate navigations (back button)
  if (savedPosition) {
    position = savedPosition
  }

  return new Promise((resolve) => {
    // wait for the out transition to complete (if necessary)
    window.$nuxt.$once('triggerScroll', () => {
      // coords will be used if no selector is provided,
      // or if the selector didn't match any element.
      if (to.hash) {
        let hash = to.hash
        // CSS.escape() is not supported with IE and Edge.
        if (typeof window.CSS !== 'undefined' && typeof window.CSS.escape !== 'undefined') {
          hash = '#' + window.CSS.escape(hash.substr(1))
        }
        try {
          if (document.querySelector(hash)) {
            // scroll to anchor by returning the selector
            position = { selector: hash }
          }
        } catch (e) {
          console.warn('Failed to save scroll position. Please add CSS.escape() polyfill (https://github.com/mathiasbynens/CSS.escape).')
        }
      }
      resolve(position)
    })
  })
}

export function createRouter() {
  return new Router({
    mode: 'history',
    base: decodeURI('/'),
    linkActiveClass: 'nuxt-link-active',
    linkExactActiveClass: 'nuxt-link-exact-active',
    scrollBehavior,

    routes: [{
      path: "/companies",
      component: _79013404,
      name: "companies"
    }, {
      path: "/logout",
      component: _50197294,
      name: "logout"
    }, {
      path: "/sign_in",
      component: _0892b4cd,
      name: "sign_in"
    }, {
      path: "/google-calendar/callback",
      component: _1765b428,
      name: "google-calendar-callback"
    }, {
      path: "/initial-settings/company-profile",
      component: _3bdc6160,
      name: "initial-settings-company-profile"
    }, {
      path: "/initial-settings/invite-members",
      component: _25e5819e,
      name: "initial-settings-invite-members"
    }, {
      path: "/initial-settings/user-profile",
      component: _03403c30,
      name: "initial-settings-user-profile"
    }, {
      path: "/sessions/branu-logout",
      component: _059f71f7,
      name: "sessions-branu-logout"
    }, {
      path: "/sessions/callback",
      component: _45d5f5dd,
      name: "sessions-callback"
    }, {
      path: "/sessions/callback-with-branu-user",
      component: _3f63e357,
      name: "sessions-callback-with-branu-user"
    }, {
      path: "/sessions/invitation",
      component: _35f82331,
      name: "sessions-invitation"
    }, {
      path: "/contents/:uuid?",
      component: _58984e32,
      name: "contents-uuid"
    }, {
      path: "/companies/:company_id/attendance-summary",
      component: _079197b3,
      name: "companies-company_id-attendance-summary"
    }, {
      path: "/companies/:company_id/construction-kinds",
      component: _56b2a5d4,
      name: "companies-company_id-construction-kinds",
      children: [{
        path: "new",
        component: _74f9be65,
        name: "companies-company_id-construction-kinds-new"
      }]
    }, {
      path: "/companies/:company_id/customers",
      component: _cbfc7a18,
      name: "companies-company_id-customers",
      children: [{
        path: "new",
        component: _13354b85,
        name: "companies-company_id-customers-new"
      }, {
        path: ":id",
        component: _325a49e2,
        name: "companies-company_id-customers-id"
      }, {
        path: ":id/edit",
        component: _7b60152a,
        name: "companies-company_id-customers-id-edit"
      }]
    }, {
      path: "/companies/:company_id/expiration",
      component: _4e35cfc0,
      name: "companies-company_id-expiration"
    }, {
      path: "/companies/:company_id/members",
      component: _64040378,
      name: "companies-company_id-members"
    }, {
      path: "/companies/:company_id/profile",
      component: _1b10fc08,
      name: "companies-company_id-profile"
    }, {
      path: "/companies/:company_id/projects",
      component: _39c7caab,
      children: [{
        path: "",
        component: _c6433624,
        name: "companies-company_id-projects"
      }, {
        path: "calendar",
        component: _5315445c,
        name: "companies-company_id-projects-calendar"
      }, {
        path: "gantt-chart",
        component: _6936ae84,
        name: "companies-company_id-projects-gantt-chart"
      }, {
        path: "new",
        component: _669ac088,
        name: "companies-company_id-projects-new"
      }, {
        path: "resource-allocation",
        component: _106ede44,
        name: "companies-company_id-projects-resource-allocation"
      }, {
        path: "resource-allocation/devices-allocation",
        component: _241aabf7,
        name: "companies-company_id-projects-resource-allocation-devices-allocation"
      }, {
        path: "resource-allocation/member-allocation",
        component: _6abe0a7c,
        name: "companies-company_id-projects-resource-allocation-member-allocation"
      }, {
        path: ":id",
        component: _8e066a54,
        children: [{
          path: "",
          component: _02ff58d9,
          name: "companies-company_id-projects-id"
        }, {
          path: "attendance",
          component: _5c0bb8f5,
          name: "companies-company_id-projects-id-attendance"
        }, {
          path: "board_posts",
          component: _62a5b7c4,
          name: "companies-company_id-projects-id-board_posts"
        }, {
          path: "card",
          component: _516375c8,
          name: "companies-company_id-projects-id-card"
        }, {
          path: "detail",
          component: _15825c4c,
          name: "companies-company_id-projects-id-detail"
        }, {
          path: "ledger",
          component: _ed59b816,
          name: "companies-company_id-projects-id-ledger"
        }, {
          path: "member",
          component: _39da10ba,
          name: "companies-company_id-projects-id-member"
        }, {
          path: "reports",
          component: _027fad89,
          name: "companies-company_id-projects-id-reports"
        }, {
          path: "schedule",
          component: _27c8ff63,
          name: "companies-company_id-projects-id-schedule"
        }, {
          path: "attendance/summary",
          component: _2fc83709,
          name: "companies-company_id-projects-id-attendance-summary"
        }, {
          path: "attendance/user-list",
          component: _37182dfa,
          name: "companies-company_id-projects-id-attendance-user-list"
        }, {
          path: "attendance/user-records",
          component: _c940e826,
          name: "companies-company_id-projects-id-attendance-user-records"
        }, {
          path: "attendance/utils",
          component: _d9a1e61e,
          name: "companies-company_id-projects-id-attendance-utils",
          children: [{
            path: "user-list",
            component: _3330d040,
            name: "companies-company_id-projects-id-attendance-utils-user-list"
          }]
        }, {
          path: "board_posts/new",
          component: _6cbcb012,
          name: "companies-company_id-projects-id-board_posts-new"
        }, {
          path: "board_posts/posts",
          component: _16cea108,
          name: "companies-company_id-projects-id-board_posts-posts"
        }, {
          path: "reports/select-daily-reports",
          component: _0446bf93,
          name: "companies-company_id-projects-id-reports-select-daily-reports"
        }, {
          path: "schedule/fullscreen",
          component: _76b02f7a,
          name: "companies-company_id-projects-id-schedule-fullscreen"
        }, {
          path: "schedule/preview",
          component: _091e15ce,
          name: "companies-company_id-projects-id-schedule-preview"
        }, {
          path: "schedule/print",
          component: _b355387e,
          name: "companies-company_id-projects-id-schedule-print"
        }, {
          path: "schedule/view",
          component: _589b2e27,
          name: "companies-company_id-projects-id-schedule-view"
        }, {
          path: "schedule/view/fullscreen",
          component: _72fec994,
          name: "companies-company_id-projects-id-schedule-view-fullscreen"
        }, {
          path: "board_posts/:board_id",
          component: _18bb62a8,
          name: "companies-company_id-projects-id-board_posts-board_id"
        }, {
          path: "files/:file_id",
          component: _5bbcdbba,
          name: "companies-company_id-projects-id-files-file_id"
        }, {
          path: "board_posts/:board_id/edit",
          component: _1fb5cba4,
          name: "companies-company_id-projects-id-board_posts-board_id-edit"
        }, {
          path: "board_posts/:board_id/files",
          component: _62c6d290,
          name: "companies-company_id-projects-id-board_posts-board_id-files"
        }, {
          path: "files/:file_id/edit",
          component: _49437e6e,
          name: "companies-company_id-projects-id-files-file_id-edit"
        }, {
          path: "files/:file_id/preview",
          component: _71efd7d9,
          name: "companies-company_id-projects-id-files-file_id-preview"
        }, {
          path: "reports/:report_id/form",
          component: _4938477a,
          name: "companies-company_id-projects-id-reports-report_id-form"
        }, {
          path: "reports/:report_id/preview",
          component: _e9a8d3ce,
          name: "companies-company_id-projects-id-reports-report_id-preview"
        }]
      }]
    }, {
      path: "/companies/:company_id/reports",
      component: _289f8121,
      name: "companies-company_id-reports"
    }, {
      path: "/companies/:company_id/setting",
      component: _0930d52f,
      name: "companies-company_id-setting"
    }, {
      path: "/companies/:company_id/sharing-contents",
      component: _7aa76f1f,
      name: "companies-company_id-sharing-contents"
    }, {
      path: "/companies/:company_id/skills-register",
      component: _52178d70,
      name: "companies-company_id-skills-register"
    }, {
      path: "/companies/:company_id/unavailability",
      component: _685d94e5,
      name: "companies-company_id-unavailability"
    }, {
      path: "/companies/:company_id/user-profile",
      component: _2ac7bcd8,
      name: "companies-company_id-user-profile"
    }, {
      path: "/companies/:company_id/skills-register/analytics",
      component: _0aac2ea7,
      name: "companies-company_id-skills-register-analytics"
    }, {
      path: "/companies/:company_id/files/:id?",
      component: _315c2004,
      name: "companies-company_id-files-id"
    }, {
      path: "/companies/:company_id/reports/:id",
      component: _53a1238c,
      name: "companies-company_id-reports-id"
    }, {
      path: "/companies/:company_id/skills-register/:member_id?",
      component: _74fdcb14,
      name: "companies-company_id-skills-register-member_id"
    }, {
      path: "/companies/:company_id/files/:id?/edit",
      component: _f8cc1a70,
      name: "companies-company_id-files-id-edit"
    }, {
      path: "/companies/:company_id/files/:id?/preview",
      component: _26831d0c,
      name: "companies-company_id-files-id-preview"
    }, {
      path: "/companies/:company_id/reports/:id/ai_pdf",
      component: _8f986ede,
      name: "companies-company_id-reports-id-ai_pdf"
    }, {
      path: "/companies/:company_id/reports/:id/edit",
      component: _3a625e40,
      name: "companies-company_id-reports-id-edit"
    }, {
      path: "/companies/:company_id/reports/:id/pdf",
      component: _9a4f07a8,
      name: "companies-company_id-reports-id-pdf"
    }, {
      path: "/companies/:company_id/project/:id?/schedule/pdf",
      component: _b7d80ad4,
      name: "companies-company_id-project-id-schedule-pdf"
    }, {
      path: "/",
      component: _7881ecb8,
      name: "index"
    }],

    fallback: false
  })
}
